import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

const BASE_URL = '/v1/admin/podcast-billing';

function useManagePodcastSubscription() {
  const queryClient = useQueryClient();
  const { privateFetch } = useContext(FetchContext);

  const actions = {
    cancel: ({ subscriptionId, reason }) =>
      privateFetch.post(`${BASE_URL}/subscriptions/${subscriptionId}/cancel`, { reason }),
    cancelAndRefund: ({ subscriptionId, reason }) =>
      privateFetch.post(`${BASE_URL}/subscriptions/${subscriptionId}/cancel-and-refund`, {
        reason,
      }),
    markRefunded: ({ paymentId, refundReference }) =>
      privateFetch.post(`${BASE_URL}/payments/${paymentId}/mark-refunded`, { refundReference }),
  };

  return useMutation(({ action, ...rest }) => actions[action](rest), {
    onSettled() {
      return Promise.all([
        queryClient.invalidateQueries('podcast-subscriptions-list'),
        queryClient.invalidateQueries('podcast-subscription-detail'),
      ]);
    },
  });
}

export default useManagePodcastSubscription;
